var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "authWrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row whiteBG-wrap"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-lg-6 col-md-6"
  }, [_c('div', {
    staticClass: "auth-form-wrap auth-form"
  }, [_c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          ref: "addFileContainer",
          on: {
            "submit": function submit($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return handleSubmit(_vm.uploadFile);
            }
          }
        }, [_c('div', {
          staticClass: "row"
        }, [_vm.form.doc_type !== 'SSN' && _vm.form.doc_type !== 'EIN' ? _c('input-text', {
          attrs: {
            "rules": _vm.form.doc_type === 'SSN' || _vm.form.doc_type === 'EIN' ? {} : {
              required: true
            },
            "labelFor": "uploaded_by",
            "labelName": "Name",
            "inputName": "name",
            "vmodel": _vm.form.uploaded_by,
            "formGroupClass": "form-group col-lg-6 col-md-6 mb-3",
            "api-errors": _vm.apiErrors
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "uploaded_by", $event);
            }
          }
        }) : _vm._e(), _vm.form.doc_type !== 'SSN' && _vm.form.doc_type !== 'EIN' ? _c('input-text', {
          attrs: {
            "rules": _vm.form.doc_type === 'SSN' || _vm.form.doc_type === 'EIN' ? {} : {
              required: true
            },
            "labelFor": "file_title",
            "labelName": "File Title",
            "inputName": "file_title",
            "vmodel": _vm.form.file_title,
            "formGroupClass": "form-group col-lg-6 col-md-6 mb-3",
            "api-errors": _vm.apiErrors
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "file_title", $event);
            }
          }
        }) : _vm._e()], 1), _c('div', {
          staticClass: "row"
        }, [_c('input-multi-select', {
          attrs: {
            "labelFor": "doc_type",
            "vmodel": _vm.form.doc_type,
            "labelName": "Type",
            "options": _vm.fileTypes.map(function (type) {
              return type.value;
            }),
            "custom-label": function customLabel(opt) {
              return _vm.fileTypes.find(function (x) {
                return x.value == opt;
              }).text;
            },
            "rules": {
              required: true
            },
            "formGroupClass": "form-group col-lg-12 col-md-12 mb-3",
            "placeholder": "Select File Type",
            "api-errors": _vm.apiErrors
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "doc_type", $event);
            }
          }
        })], 1), _vm.form.doc_type === 'SSN' ? _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-lg-12 col-md-12 mb-3"
        }, [_c('div', {
          staticClass: "form-group mb-3 position-relative"
        }, [_c('label', {
          staticClass: "form-label",
          attrs: {
            "for": "ssn"
          }
        }, [_vm._v("Social Security Number (SSN)")]), _c('div', {
          staticClass: "input-group"
        }, [(_vm.showSSN ? 'text' : 'password') === 'checkbox' ? _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.form.ssn,
            expression: "form.ssn"
          }],
          staticClass: "form-control",
          attrs: {
            "id": "ssn",
            "name": "ssn",
            "placeholder": "Enter 9-digit SSN",
            "maxlength": "9",
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(_vm.form.ssn) ? _vm._i(_vm.form.ssn, null) > -1 : _vm.form.ssn
          },
          on: {
            "input": _vm.validateSSN,
            "keypress": _vm.onlyNumbers,
            "change": function change($event) {
              var $$a = _vm.form.ssn,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false;

              if (Array.isArray($$a)) {
                var $$v = null,
                    $$i = _vm._i($$a, $$v);

                if ($$el.checked) {
                  $$i < 0 && _vm.$set(_vm.form, "ssn", $$a.concat([$$v]));
                } else {
                  $$i > -1 && _vm.$set(_vm.form, "ssn", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
                }
              } else {
                _vm.$set(_vm.form, "ssn", $$c);
              }
            }
          }
        }) : (_vm.showSSN ? 'text' : 'password') === 'radio' ? _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.form.ssn,
            expression: "form.ssn"
          }],
          staticClass: "form-control",
          attrs: {
            "id": "ssn",
            "name": "ssn",
            "placeholder": "Enter 9-digit SSN",
            "maxlength": "9",
            "type": "radio"
          },
          domProps: {
            "checked": _vm._q(_vm.form.ssn, null)
          },
          on: {
            "input": _vm.validateSSN,
            "keypress": _vm.onlyNumbers,
            "change": function change($event) {
              return _vm.$set(_vm.form, "ssn", null);
            }
          }
        }) : _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.form.ssn,
            expression: "form.ssn"
          }],
          staticClass: "form-control",
          attrs: {
            "id": "ssn",
            "name": "ssn",
            "placeholder": "Enter 9-digit SSN",
            "maxlength": "9",
            "type": _vm.showSSN ? 'text' : 'password'
          },
          domProps: {
            "value": _vm.form.ssn
          },
          on: {
            "input": [function ($event) {
              if ($event.target.composing) { return; }

              _vm.$set(_vm.form, "ssn", $event.target.value);
            }, _vm.validateSSN],
            "keypress": _vm.onlyNumbers
          }
        }), _c('button', {
          staticClass: "btn btn-outline-secondary",
          staticStyle: {
            "border-left": "none"
          },
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.showSSN = !_vm.showSSN;
            }
          }
        }, [_c('i', {
          class: _vm.showSSN ? 'fas fa-eye-slash' : 'fas fa-eye'
        })])]), _vm.ssnError ? _c('div', {
          staticClass: "valid-error mt-2"
        }, [_vm._v(" " + _vm._s(_vm.ssnError) + " ")]) : _vm._e()])])]) : _vm._e(), _vm.form.doc_type === 'EIN' ? _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-lg-12 col-md-12 mb-3"
        }, [_c('div', {
          staticClass: "form-group mb-3 position-relative"
        }, [_c('label', {
          staticClass: "form-label",
          attrs: {
            "for": "ein"
          }
        }, [_vm._v("Employer Identification Number (EIN)")]), _c('div', {
          staticClass: "input-group"
        }, [(_vm.showEIN ? 'text' : 'password') === 'checkbox' ? _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.form.ein,
            expression: "form.ein"
          }],
          staticClass: "form-control",
          attrs: {
            "id": "ein",
            "name": "ein",
            "placeholder": "Enter 9-digit EIN",
            "maxlength": "9",
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(_vm.form.ein) ? _vm._i(_vm.form.ein, null) > -1 : _vm.form.ein
          },
          on: {
            "input": _vm.validateEIN,
            "keypress": _vm.onlyNumbers,
            "change": function change($event) {
              var $$a = _vm.form.ein,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false;

              if (Array.isArray($$a)) {
                var $$v = null,
                    $$i = _vm._i($$a, $$v);

                if ($$el.checked) {
                  $$i < 0 && _vm.$set(_vm.form, "ein", $$a.concat([$$v]));
                } else {
                  $$i > -1 && _vm.$set(_vm.form, "ein", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
                }
              } else {
                _vm.$set(_vm.form, "ein", $$c);
              }
            }
          }
        }) : (_vm.showEIN ? 'text' : 'password') === 'radio' ? _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.form.ein,
            expression: "form.ein"
          }],
          staticClass: "form-control",
          attrs: {
            "id": "ein",
            "name": "ein",
            "placeholder": "Enter 9-digit EIN",
            "maxlength": "9",
            "type": "radio"
          },
          domProps: {
            "checked": _vm._q(_vm.form.ein, null)
          },
          on: {
            "input": _vm.validateEIN,
            "keypress": _vm.onlyNumbers,
            "change": function change($event) {
              return _vm.$set(_vm.form, "ein", null);
            }
          }
        }) : _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.form.ein,
            expression: "form.ein"
          }],
          staticClass: "form-control",
          attrs: {
            "id": "ein",
            "name": "ein",
            "placeholder": "Enter 9-digit EIN",
            "maxlength": "9",
            "type": _vm.showEIN ? 'text' : 'password'
          },
          domProps: {
            "value": _vm.form.ein
          },
          on: {
            "input": [function ($event) {
              if ($event.target.composing) { return; }

              _vm.$set(_vm.form, "ein", $event.target.value);
            }, _vm.validateEIN],
            "keypress": _vm.onlyNumbers
          }
        }), _c('button', {
          staticClass: "btn btn-outline-secondary",
          staticStyle: {
            "border-left": "none"
          },
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.showEIN = !_vm.showEIN;
            }
          }
        }, [_c('i', {
          class: _vm.showEIN ? 'fas fa-eye-slash' : 'fas fa-eye'
        })])]), _vm.einError ? _c('div', {
          staticClass: "valid-error mt-2"
        }, [_vm._v(" " + _vm._s(_vm.einError) + " ")]) : _vm._e()])])]) : _vm._e(), _vm.form.doc_type !== 'SSN' && _vm.form.doc_type !== 'EIN' ? _c('input-file', {
          attrs: {
            "rules": _vm.form.doc_type !== 'SSN' && _vm.form.doc_type !== 'EIN' ? {
              required: true,
              mimes: _vm.mimeTypes
            } : {},
            "labelFor": "file",
            "labelName": "Select File (txt, png, jpg, jpeg, xlsx, pdf, csv, doc and pptx) ",
            "inputName": "select_file",
            "vmodel": _vm.file,
            "acceptMimeTypes": _vm.mimeTypes,
            "api-errors": _vm.apiErrors,
            "formGroupClass": "form-group mb-3"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              _vm.file = $event;
            }
          }
        }) : _vm._e(), _vm.form.doc_type !== 'SSN' && _vm.form.doc_type !== 'EIN' ? _c('input-textarea', {
          attrs: {
            "rules": _vm.form.doc_type !== 'SSN' && _vm.form.doc_type !== 'EIN' ? {
              required: true
            } : {},
            "labelFor": "file",
            "labelName": "File Notes ",
            "inputName": "file",
            "vmodel": _vm.form.doc_notes,
            "formGroupClass": "form-group mb-3",
            "api-errors": _vm.apiErrors
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "doc_notes", $event);
            }
          }
        }) : _vm._e(), _c('div', {
          staticClass: "auth-form upload-file-share-btn",
          on: {
            "keypress": _vm.onlyNumbers
          }
        }, [_c('h5', [_vm._v("Enter OTP")]), _c('v-otp-input', {
          ref: "otpInput",
          attrs: {
            "input-classes": _vm.errorClass + ' otp-input',
            "separator": "",
            "num-inputs": 6,
            "should-auto-focus": true,
            "is-input-num": true,
            "input-type": "text"
          },
          on: {
            "on-change": _vm.handleOnChange,
            "on-complete": _vm.handleOnComplete
          }
        }), _vm.apiErrors && _vm.apiErrors.otp ? _c('div', {
          staticClass: "valid-error mt-2"
        }, [_vm._v(" " + _vm._s(_vm.apiErrors.otp[0]) + " ")]) : _vm._e()], 1), _c('div', {
          staticClass: "col-md-12 upload-file-action"
        }, [_c('button', {
          class: _vm.isOtpComplete ? 'submit-btn' : 'disable-submit-btn',
          attrs: {
            "type": "submit",
            "disabled": _vm.isUpload || !_vm.isOtpComplete
          }
        }, [_vm._v(" " + _vm._s(_vm.isUpload ? "Uploading...." : "Upload") + " ")])])], 1)];
      }
    }])
  })], 1)])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-lg-6 col-md-6 no-padding"
  }, [_c('div', {
    staticClass: "left-bg-wrapper text-center"
  }, [_c('h1', [_vm._v("Hello")]), _c('p', [_vm._v("Please enter otp to upload your file.")])])]);
}]

export { render, staticRenderFns }